<template>
  <div v-loading="loading">
    <div>
      <el-form
        size="mini"
        label-position="left"
        label-width="250px"
      >
        <el-form-item label="Название">
          <div style="display: flex">
            <click-to-edit
              :word-limit="1000"
              style="width: 100%"
              v-model="scale.name"
              @input="updateScale"
            ></click-to-edit>
          </div>
        </el-form-item>
        <el-form-item label="Описание">
          <div style="display: flex">
            <click-to-edit
              type="textarea"
              :word-limit="10000"
              style="width: 100%"
              v-model="scale.description"
              @input="updateScale"
            ></click-to-edit>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <options-component
      v-show="visible"
      :scale="scale"
      @update-scale="updateScale"
    ></options-component>

    <div style="display: flex; justify-content: space-between; margin-top: 20px">
      <div>
        <el-button
          size="mini"
          :icon="visible ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
          @click="toggleScaleVisibility"
        >
          {{ visible ? 'Свернуть': 'Развернуть' }}
        </el-button>
      </div>

      <div>
        <el-switch
          v-model="scale.disabled"
          :active-value="false"
          :inactive-value="true"
          active-text="Активная"
          @change="updateScale"
        >
        </el-switch>

        <el-popconfirm
          style="margin-left: 15px"
          confirm-button-text='Да'
          cancel-button-text='нет'
          icon="el-icon-question"
          title="Вы уверены, что хотите удалить шкалу?"
          @confirm="deleteScale"
        >
          <el-button
            slot="reference"
            size="mini"
            plain
            icon="far fa-trash-alt"
            :loading="loading"
          >
            Удалить
          </el-button>
        </el-popconfirm>
      </div>
    </div>
  </div>
</template>

<script>
import OptionsComponent from "@/modules/evaluation/components/scale/OptionsComponent.vue";
import ClickToEdit from "@/components/ClickToEdit.vue";
import PageHeading from "@/components/PageHeading.vue";

export default {
  name: "scale-component",
  components: { PageHeading, ClickToEdit, OptionsComponent },
  props: {
    scale: {type: Object, required: true},
  },
  data() {
    return {
      loading: false,
      visible: false,
    }
  },
  mounted() {
    const visibleSettings = JSON.parse( localStorage.getItem('scalesVisibility') || '{}' );
    this.visible = visibleSettings[this.scale.id] || false;
  },
  methods: {
    toggleScaleVisibility(){
      this.visible = !this.visible;
      let settings = JSON.parse( localStorage.getItem('scalesVisibility') || '{}' );
      settings[this.scale.id] = this.visible;
      localStorage.setItem('scalesVisibility', JSON.stringify(settings));
    },
    updateScale() {
      this.loading = true;

      this.$api.evaluation.scaleUpdate({
        id: this.scale.id,
        name: this.scale.name ?? null,
        description: this.scale.description ?? null,
        disabled: this.scale.disabled ?? false,
        has_unsure_option: this.scale.has_unsure_option ?? false,
      })
        .then(data => {
          this.$emit('scale-update');
          this.$notify.success({
            title: 'Обновлено',
            message: 'Шкала успешно обновлена'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    deleteScale() {
      this.loading = true;
      this.$api.evaluation.scaleDelete({
        ids: [this.scale.id]
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Шкала успешно удалена'
          });
          this.$emit('scale-update');
        })
        .finally(() => {
          this.loading = false;
        })
    },
  }
}
</script>

<style scoped>

</style>